import makeApiRequest from './makeApiRequest';

export interface CaptureContext {
	jwt: string;
	clientLibrary: string;
	exp: number;
}

const decodeJwtPayload = (jwt: string): any => {
	try {
		const payload = jwt.split('.')[1];
		return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
	} catch {
		return {};
	}
};

const getCbsCaptureContext = () => {
	const getApiRequest = makeApiRequest('GET');

	const getCaptureContext = async (apiBase: string, fairId?: string) => {
		const url = fairId ? `${apiBase}/api/cyber-source/capture-context?fairId=${encodeURIComponent(fairId)}` : `${apiBase}/api/cyber-source/capture-context`;
		const { data, error } = await getApiRequest(url, {});
		if (error || data == null) {
			return { data: null, error };
		}

		const jwt: string = data.captureContextJwt;
		const payload = decodeJwtPayload(jwt);
		const captureContext: CaptureContext = {
			jwt,
			clientLibrary: payload?.ctx?.[0]?.data?.clientLibrary ?? '',
			exp: payload?.exp ?? 0,
		};

		return { data: captureContext, error: null };
	};

	return [getCaptureContext];
};

export default getCbsCaptureContext;
